import ScriptingEffect from './ScriptingEffect.js';
import {pipe} from './pipe.js';
import {
    execute,
    grabTime
} from './lang.js';

class GrabTime extends ScriptingEffect {
    constructor(track) {
        super("Grab Time", track);
        this.newTrackVar("trackNumber", null, 0, 64);
        this.clear();
    }

    get documentation() {
        return [
            "Sets a parameter for this track to a value grabbed from a different track.",
            "If there are no triggers at a given step, then the original value will play."
            ];
    }

    isRealTime() {
        return false;
    }

    clear() {
        this.myScript = pipe(
            grabTime(
                this.var('trackNumber'),
            ));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track=this.track, ignoreId=true) {
        let fx = new GrabTime(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}

export default GrabTime;
